import { useContext } from 'react';
import { ConfigContext, type IConfigContext } from './context';

const useConfig = () => {
  const context = useContext<IConfigContext>(ConfigContext);

  return context;
};

export default useConfig;
